import { useBrand } from '@/contexts/BrandContext'

export function useBrandAware() {
  const { isComponentBranded } = useBrand()

  const getBrandProps = (component: 'buttons' | 'cards' | 'inputs', componentId?: string) => {
    const isBranded = isComponentBranded(component, componentId)
    
    switch (component) {
      case 'buttons':
        return isBranded ? {
          variant: 'brand-primary' as const
        } : {}
      
      case 'cards':
        return isBranded ? {
          variant: 'brand' as const
        } : {}
      
      case 'inputs':
        return isBranded ? {
          variant: 'brand' as const
        } : {}
      
      default:
        return {}
    }
  }

  const getBrandClasses = (component: 'buttons' | 'cards' | 'inputs', componentId?: string) => {
    const isBranded = isComponentBranded(component, componentId)
    
    if (!isBranded) return ''
    
    switch (component) {
      case 'buttons':
        return 'brand-btn-primary'
      case 'cards':
        return 'brand-card'
      case 'inputs':
        return 'brand-input'
      default:
        return ''
    }
  }

  const getBrandStyles = (component: 'layout' | 'text', componentId?: string) => {
    const isBranded = isComponentBranded('global', componentId)
    
    if (!isBranded) return {}
    
    switch (component) {
      case 'layout':
        return {
          backgroundColor: 'hsl(var(--chalk))',
          color: 'hsl(var(--midnight))'
        }
      case 'text':
        return {
          color: 'hsl(var(--midnight))'
        }
      default:
        return {}
    }
  }

  return {
    getBrandProps,
    getBrandClasses,
    getBrandStyles,
    isComponentBranded
  }
}